import React, { useState, useEffect, useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import PageLayout from '@/components/PageLayout'
import Header from '@/components/Header'
import Back from '@/components/Back'
import VerificationCodeInput from '@/components/VerificationCodeInput'
import CustomTextInput from '@/components/CustomTextInput'
import CustomButton from '@/components/CustomButton'
import { CardActionType } from '../../index.type'
import { useSendCode } from '@/hooks/useSendCode'
import { APIWeb } from '@/api/index'

export default React.memo(function VerOldAccountCode() {
    const navigate = useNavigate()
    const { t } = useTranslation()
    const { state } = useLocation()
    console.log('verifyOldAccount', state)
    const { sendCode, sendCodeLoading } = useSendCode()
    const [submitLoading, setSubmitLoading] = useState(false)
    const [googleCode, setGoogleCode] = useState('')
    // 从 URL 查询参数读取验证码数据

    const handleCodeChange = useCallback((value: string) => {
        const numericValue = value.replace(/\D/g, '').slice(0, 6)
        setGoogleCode(numericValue)
    }, [])


    const handleResendCode = useCallback(async () => {
        await sendCode({
            account: state?.account || '',
            scene: 'change_account',
        })
    }, [sendCode, state?.account])

    const googleInputVer = useMemo(() => {
        return (
            <div>
                <div className="space-y-2">
                    <div className="text-3 text-[#1A1A1A]/60 mb-1">{t('请输入谷歌验证码')}</div>
                    <CustomTextInput
                        value={googleCode}
                        onChangeText={handleCodeChange}
                        placeholder={t('请输入谷歌验证码')}
                    />
                </div>
                <div className="mt-6">
                    <CustomButton
                        loading={submitLoading}
                        disabled={submitLoading || !googleCode}
                        onClick={() => handleSubmit(googleCode)}
                    >
                        {t('立即验证')}
                    </CustomButton>
                </div>
            </div>

        )
    }, [googleCode, submitLoading])

    // 提交验证码验证得到verify_key跳转设置新账户界面
    
    const handleSubmit = async (code: string) => {
        setSubmitLoading(true)
        try {
            const data = await APIWeb.verifyOldAccountCode({
                account: state?.account || 'google',
                scene: 'change_account',
                code,
            })
            if (data) {
                const path = state?.changeType === CardActionType.Google ? '/change-account/new-google' : '/change-account/new-account'
                navigate(path, {
                    state: {
                        account: state?.account || '',
                        ...state,
                        verify_key: data?.verify_key || '',
                    },
                })

            }
        } catch (error) {
            console.log('error', error)
        } finally {
            setSubmitLoading(false)
        }
    }
    return (
        <PageLayout>
            <Header leftChildren={<Back />} />
            {/* Content */}
            <div className="px-6 py-6">
                {
                    state?.account ? (
                        <VerificationCodeInput
                            account={state?.account}
                            resendLoading={sendCodeLoading}
                            submitLoading={submitLoading}
                            onResendCode={handleResendCode}
                            onSubmit={handleSubmit}
                            submitButtonText={t('立即验证')}
                        />
                    ) : googleInputVer
                }

            </div>
        </PageLayout>
    )
})
